import React from 'react';
import useCachedImgURL from 'src/components/10-atoms/image/useCachedImgURL';
import withThemeProvider from 'src/customizations/themes/hoc/withThemeProvider';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import withPress from 'src/hoc/withPress';
const DiagramItem = ({ diagram }) => {
    const [{ theme }] = useTheme();
    const cachedSrc = useCachedImgURL(diagram.data.imageURL);
    return (React.createElement("div", { key: diagram.id, style: {
            backgroundImage: `url('${cachedSrc.data}')`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: theme.palette.background.main,
            width: '100%',
            height: '100%',
            border: `1px solid ${theme.palette.border.main}`,
            borderRadius: `${theme.borderRadius.standard.md}px`,
            boxSizing: 'border-box',
        } }));
};
export default withPress(withThemeProvider(DiagramItem, 'light'));
